// routes
import BusinessIcon from '@mui/icons-material/Business';
import CategoryIcon from '@mui/icons-material/Category';
import HandshakeRoundedIcon from '@mui/icons-material/HandshakeRounded';
import ReportIcon from '@mui/icons-material/Report';
import ReviewsIcon from '@mui/icons-material/Reviews';
import BadgeIcon from '@mui/icons-material/Badge';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import shoppingBagFill from '@iconify/icons-eva/shopping-bag-fill';
import {
  PATH_STORE,
  PATH_CUSTOMER,
  PATH_PRODUCTS_SERVICES,
  PATH_PRODUCTS,
  PATH_ADVERTISEMENT,
  PATH_EVENTS,
  PATH_CATEGORY,
  PATH_ANALYTICS,
  PATH_B2B_PARTNERS,
  // PATH_ROUTE,
  PATH_REPORT,
  PATH_OFFER_REPORT,
  PATH_EVENT_REPORT,
  PATH_VEHICLES,
  PATH_NEW_VEHICLES,
  PATH_USER_PROFILE,
  PATH_RATING_AND_REVIEWS,
  PATH_OFFERS,
  PATH_BUSINESS,
  PATH_SCHOOL,
  PATH_FEATURE,
  PATH_CUSTOMER_ANALYTICS,
  PATH_PRIVILEDGED,
  PATH_SPEMPLOYEE
} from 'routes/paths';
import PeopleIcon from '@mui/icons-material/People';
// components
import USER_ROLE from 'utils/constants/userRole';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import LibraryAddRoundedIcon from '@mui/icons-material/LibraryAddRounded';
import ElectricRickshawRoundedIcon from '@mui/icons-material/ElectricRickshawRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import EmojiTransportationRoundedIcon from '@mui/icons-material/EmojiTransportationRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import SvgIconStyle from '../../components/SvgIconStyle';
// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  advertisement: getIcon('ic_dashboard'),
  dashboard: <DashboardIcon />,
  business: <BusinessIcon />,
  employee: <PeopleIcon />,
  prodCat: <CategoryIcon />,
  b2b: <HandshakeRoundedIcon />,
  report: <ReportIcon />,
  vehicle: <DirectionsCarIcon />,
  newVehicle: <LocalShippingRoundedIcon />,
  rating: <ReviewsIcon />,
  eventIcon: <EventAvailableRoundedIcon />,
  plusIcon: <LibraryAddRoundedIcon />,
  auto: <ElectricRickshawRoundedIcon />,
  analytics: <AssessmentRoundedIcon />,
  priviledge: <VpnKeyIcon />,
  spEmployee: <BadgeIcon />
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'general',
  //   items: [
  //     { title: 'One', path: PATH_DASHBOARD.general.pageOne, icon: ICONS.dashboard },
  //     { title: 'Two', path: PATH_DASHBOARD.general.pageTwo, icon: ICONS.ecommerce },
  //     { title: 'Three', path: PATH_DASHBOARD.general.pageThree, icon: ICONS.analytics }
  //   ]
  // },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    items: [
      // {
      //   title: 'User Profile',
      //   path: PATH_USER_PROFILE.root,
      //   accessibleRoles: [USER_ROLE.OEM, USER_ROLE.EMPLOYEE],
      //   icon: ICONS.user,
      //   key: 'USER_PROFILE'
      // },
      {
        title: 'Dashboard',
        path: PATH_ANALYTICS.root,
        icon: ICONS.dashboard,
        key: 'DASHBOARD'
        // children: [
        //   // { title: 'create', path: PATH_STORE.create },
        //   { title: 'list', path: PATH_ANALYTICS.root }
        // ]
      },
      {
        title: 'Analytics',
        // path: PATH_CUSTOMER_ANALYTICS.root,
        accessibleRoles: [USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE],
        icon: ICONS.analytics,
        children: [
          { title: 'Customer', path: PATH_CUSTOMER_ANALYTICS.customerList },
          { title: 'Advertisement & Plus Feature', path: PATH_CUSTOMER_ANALYTICS.plusFeatureList },
          { title: 'Partner', path: PATH_CUSTOMER_ANALYTICS.partnerList }
          // { title: 'Buy Vehicle', path: PATH_CUSTOMER_ANALYTICS.buyVehicleList }
        ],
        key: 'ADMIN_ANALYTICS'
      },
      {
        title: 'Analytics',
        path: PATH_CUSTOMER_ANALYTICS.customerList,
        accessibleRoles: [USER_ROLE.OEM, USER_ROLE.EMPLOYEE],
        icon: ICONS.analytics,
        key: 'OEM_ANALYTICS'
      },
      {
        title: 'Stores',
        path: PATH_STORE.root,
        icon: ICONS.business,
        key: 'STORES'
        // children: [
        //   { title: 'create', path: PATH_STORE.create },
        //   { title: 'list', path: PATH_STORE.root }
        // ]
      },
      {
        title: 'Customer',
        path: PATH_CUSTOMER.root,
        // accessibleRoles: [USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE],
        icon: ICONS.user,
        key: 'CUSTOMER'
        // children: [{ title: 'list', path: PATH_CUSTOMER.root }]
      },
      {
        title: 'Buy/Sell',
        path: PATH_VEHICLES.root,
        // accessibleRoles: [USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE, USER_ROLE.OEM],
        icon: ICONS.vehicle,
        key: 'VEHICLES_BUY_SELL'
        // children: [{ title: 'list', path: PATH_VEHICLES.root }]
      },
      {
        title: 'New Vehicles',
        path: PATH_NEW_VEHICLES.list,
        // accessibleRoles: [USER_ROLE.ADMIN],
        icon: ICONS.newVehicle,
        key: 'NEW_VEHICLES'
        // children: [{ title: 'list', path: PATH_VEHICLES.root }]
      },
      {
        title: 'Product & Services',
        path: PATH_PRODUCTS_SERVICES.list,
        accessibleRoles: [USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE],
        icon: ICONS.ecommerce,
        key: 'ADMIN_PRODUCT_AND_SERVICES'
        // children: [
        //   { title: 'create', path: PATH_PRODUCTS_SERVICES.create },
        //   { title: 'list', path: PATH_PRODUCTS_SERVICES.list }
        // ]
      },
      {
        title: 'Products',
        path: PATH_PRODUCTS.list,
        accessibleRoles: [USER_ROLE.OEM, USER_ROLE.EMPLOYEE],
        icon: ICONS.ecommerce,
        key: 'OEM_PRODUCTS'
        // children: [
        //   { title: 'create', path: PATH_PRODUCTS.create },
        //   { title: 'list', path: PATH_PRODUCTS.list }
        // ]
      },
      {
        title: 'Category',
        path: PATH_CATEGORY.list,
        // accessibleRoles: [USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE],
        icon: ICONS.prodCat,
        key: 'CATEGORY'
        // children: [
        //   { title: 'create', path: PATH_CATEGORY.create },
        //   { title: 'list', path: PATH_CATEGORY.list }
        // ]
      },
      {
        title: 'Advertisements',
        path: PATH_ADVERTISEMENT.banners,
        // accessibleRoles: [USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE],
        icon: ICONS.dashboard,
        key: 'ADVERTISEMENTS'
        // children: [
        //   { title: 'create', path: PATH_ADVERTISEMENT.create },
        //   { title: 'list', path: PATH_ADVERTISEMENT.banners }
        // ]
      },
      {
        title: 'Plus Features',
        path: PATH_FEATURE.root,
        accessibleRoles: [USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE],
        icon: ICONS.plusIcon,
        key: 'PLUS_FEATURES'
      },
      {
        title: 'Offers',
        path: PATH_OFFERS.list,
        accessibleRoles: [USER_ROLE.OEM, USER_ROLE.EMPLOYEE],
        icon: ICONS.eventIcon,
        key: 'OEM_OFFERS'
        // children: [
        //   { title: 'Partner App', path: PATH_OFFERS.partnerCreate },
        //   // { title: 'Customer App', path: PATH_OFFERS.customerCreate },
        //   { title: 'list', path: PATH_OFFERS.list }
        // ]
      },
      {
        title: 'B2B Partners',
        path: PATH_B2B_PARTNERS.list,
        accessibleRoles: [USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE],
        icon: ICONS.b2b,
        key: 'B2B_PARTNERS'
        // children: [
        //   // { title: 'create', path: PATH_B2B_PARTNERS.create },
        //   { title: 'list', path: PATH_B2B_PARTNERS.list }
        // ]
      },
      {
        title: 'Report',
        path: PATH_REPORT.root,
        // accessibleRoles: [USER_ROLE.ADMIN],
        icon: ICONS.report,
        key: 'REPORT'
      },
      {
        title: 'Rating and Reviews',
        path: PATH_RATING_AND_REVIEWS.root,
        // accessibleRoles: [USER_ROLE.ADMIN],
        icon: ICONS.rating,
        key: 'RATING_AND_REVIEWS'
      },
      {
        title: 'Permission',
        path: PATH_PRIVILEDGED.root,
        // accessibleRoles: [USER_ROLE.ADMIN, USER_ROLE.OEM],
        icon: ICONS.priviledge,
        key: 'PERMISSION'
      },
      {
        title: 'User',
        path: PATH_SPEMPLOYEE.root,
        // accessibleRoles: [USER_ROLE.ADMIN, USER_ROLE.OEM],
        icon: ICONS.spEmployee,
        key: 'USER'
      }
    ]
  }
];

export default sidebarConfig;
